import { gql } from '@apollo/client';
import { useGenericOnError } from '@modernloop/shared/hooks';

import { useCandidateAvailabilityOptionsDeleteMutation } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CandidateAvailabilityOptionsDelete = gql`
  mutation CandidateAvailabilityOptionsDelete($id: uuid!) {
    candidateAvailabilityOptionsDelete(id: $id) {
      result
    }
  }
`;

type DeleteMutation = ReturnType<typeof useCandidateAvailabilityOptionsDeleteMutation>;

const useDeleteCandidateAvailabilityOptions = (): {
  deleteCandidateAvailabilityOptionsMutation: DeleteMutation['0'];
  deleting: DeleteMutation['1']['loading'];
  error: DeleteMutation['1']['error'];
} => {
  const handleError = useGenericOnError();

  const [deleteCandidateAvailabilityOptionsMutation, { loading: deleting, error }] =
    useCandidateAvailabilityOptionsDeleteMutation({
      onError: (err) => {
        handleError({ error: err });
      },
    });

  return { deleteCandidateAvailabilityOptionsMutation, deleting, error };
};

export default useDeleteCandidateAvailabilityOptions;
